<template>
  <div class="sidebar d-flex flex-column border-left glass-sidebar h-100" style="width: 320px; flex-shrink: 0; z-index: 30">
    <div class="pa-4 border-bottom d-flex align-center justify-space-between glass-header-inner">
      <div class="text-subtitle-1 font-weight-bold white--text d-flex align-center">
        <v-icon color="blue accent-2" class="mr-2">mdi-view-dashboard-outline</v-icon>
        Vorlagen
      </div>
      <v-btn icon small color="blue accent-2" @click="$emit('create')"><v-icon>mdi-plus</v-icon></v-btn>
    </div>

    <div class="flex-grow-1 overflow-y-auto custom-scrollbar pa-3">
      <div class="section-label mb-2 mt-1 green--text text--accent-3 text-caption font-weight-bold text-uppercase">Quick Actions</div>
      <div
        v-for="tpl in specialTemplates"
        :key="tpl.id"
        class="template-card mb-2 pa-3 rounded-lg d-flex align-center cursor-grab elevation-2 glass-card"
        draggable="true"
        @dragstart="onDragStart($event, tpl)">
        <v-avatar size="36" :color="tpl.color" class="mr-3 elevation-1">
          <v-icon small color="white">{{ tpl.icon }}</v-icon>
        </v-avatar>
        <div class="flex-grow-1 overflow-hidden">
          <div class="font-weight-bold white--text text-body-2">{{ tpl.title }}</div>
          <div class="text-caption grey--text">{{ tpl.duration }} Min • Kunde</div>
        </div>
        <v-icon small color="grey">mdi-drag-vertical</v-icon>
      </div>

      <v-divider class="my-4 border-light"></v-divider>

      <div class="section-label mb-2 pl-1 blue--text text--accent-2 text-caption font-weight-bold text-uppercase">Termine</div>
      <div
        v-for="tpl in appointmentTemplates"
        :key="tpl._id"
        class="template-card mb-2 pa-3 rounded-lg d-flex align-center cursor-grab elevation-2 glass-card"
        draggable="true"
        @dragstart="onDragStart($event, tpl)">
        <v-avatar size="36" :color="tpl.color || 'blue'" class="mr-3 elevation-1">
          <v-icon small color="white">{{ tpl.icon || "mdi-calendar" }}</v-icon>
        </v-avatar>
        <div class="flex-grow-1 overflow-hidden">
          <div class="font-weight-bold white--text text-body-2 text-truncate">{{ tpl.title }}</div>
          <div class="text-caption grey--text">{{ tpl.duration }} Min <span v-if="tpl.requiresCustomer">• Kunde</span></div>
        </div>
        <v-icon small color="grey" class="handle-icon">mdi-drag-vertical</v-icon>
      </div>

      <div class="section-label mb-2 pl-1 purple--text text--accent-2 text-caption font-weight-bold text-uppercase mt-4">Ämtli & Aufgaben</div>
      <div
        v-for="tpl in taskTemplates"
        :key="tpl._id"
        class="template-card mb-2 pa-3 rounded-lg d-flex align-center cursor-grab elevation-2 glass-card"
        draggable="true"
        @dragstart="onDragStart($event, tpl)">
        <v-avatar size="36" tile class="mr-3 rounded bg-transparent">
          <v-icon :color="tpl.color || 'purple'">{{ tpl.icon || "mdi-checkbox-marked" }}</v-icon>
        </v-avatar>
        <div class="flex-grow-1 overflow-hidden">
          <div class="font-weight-bold white--text text-body-2 text-truncate">{{ tpl.title }}</div>
          <div class="text-caption grey--text">Aufgabe</div>
        </div>
        <v-icon small color="grey" class="handle-icon">mdi-drag-vertical</v-icon>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WorkCalendarSidebar",
  props: {
    templates: { type: Array, default: () => [] },
  },
  data() {
    return {
      specialTemplates: [
        {
          id: "sp1",
          title: "Trainingsplan",
          type: "appointment",
          specialType: "workout",
          duration: 60,
          color: "#00C853",
          icon: "mdi-dumbbell",
          requiresCustomer: true,
        },
        {
          id: "sp2",
          title: "Anamnese",
          type: "appointment",
          specialType: "anamnese",
          duration: 20,
          color: "#009688",
          icon: "mdi-clipboard-pulse",
          requiresCustomer: true,
        },
        {
          id: "sp3",
          title: "Upgrade",
          type: "appointment",
          specialType: "upgrade",
          duration: 30,
          color: "#AA00FF",
          icon: "mdi-star-circle",
          requiresCustomer: true,
        },
      ],
    }
  },
  computed: {
    appointmentTemplates() {
      return this.templates.filter((t) => t.type === "appointment")
    },
    taskTemplates() {
      return this.templates.filter((t) => t.type === "task")
    },
  },
  methods: {
    onDragStart(e, tpl) {
      e.dataTransfer.setData("templateObj", JSON.stringify(tpl))
      e.dataTransfer.effectAllowed = "copy"
      this.$emit("drag-start", tpl)
    },
  },
}
</script>

<style scoped>
.glass-sidebar {
  background: rgba(20, 20, 20, 0.95);
  backdrop-filter: blur(20px);
  border-left: 1px solid rgba(255, 255, 255, 0.1);
}
.glass-header-inner {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.glass-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.05);
  transition: 0.2s;
}
.glass-card:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-2px);
}
.border-light {
  border-color: rgba(255, 255, 255, 0.1) !important;
}
.cursor-grab {
  cursor: grab;
}
</style>
